const EXTERNAL_TARGET = '_blank';
const EXTERNAL_REL = 'noopener noreferrer';
const FINRA_HOSTNAME = 'www.finra.org';

interface LinkTargetOptions {
  href?: string;
  target?: string;
  rel?: string;
}

interface ResolvedLinkTarget {
  target?: string;
  rel?: string;
}

export function shouldOpenInNewTab(href?: string): boolean {
  if (!href) {
    return false;
  }

  if (href.startsWith('/')) {
    return false;
  }

  try {
    return new URL(href).hostname === FINRA_HOSTNAME;
  } catch {
    return false;
  }
}

export function resolveLinkTarget({
  href,
  target,
  rel,
}: LinkTargetOptions): ResolvedLinkTarget {
  if (target != null || rel != null) {
    return { target, rel };
  }

  if (!shouldOpenInNewTab(href)) {
    return {};
  }

  return {
    target: EXTERNAL_TARGET,
    rel: EXTERNAL_REL,
  };
}
